<div class="dialog-title" mat-dialog-title>
    <cerrix-title
        style="flex: 1"
        size="large"
        [editable]="false"
        [value]="dialogTitle"
        [dataUiid]="'incident-document-popup'"
    ></cerrix-title>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    @if (dialogData.openReason === "Add") {
        <ng-container *ngTemplateOutlet="documentFormTemplate"></ng-container>
    } @else {
        <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab labelClass="cerrix-mat-tab" label="Document details">
                <ng-container *ngTemplateOutlet="documentFormTemplate"></ng-container>
            </mat-tab>
            <mat-tab label="History">
                @if (historyLoaded) {
                    @if (historyDocuments.length > 0) {
                        <ng-container *ngTemplateOutlet="documentHistoryTemplate"></ng-container>
                    } @else {
                        <div class="no-history">No history available for this document.</div>
                    }
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </mat-tab>
        </mat-tab-group>
    }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <cerrix-button
        color="accent"
        [dataUiid]="'incident-document-popup-close-button'"
        mat-dialog-close
        >Close</cerrix-button
    >

    @if (dialogData.openReason !== "View") {
        <cerrix-button
            color="success"
            [dataUiid]="'incident-document-popup-apply-changes-button'"
            [disabled]="dialogData.documents.length === 0"
            (click)="onApplyChanges()"
            >{{ btnLabel }}</cerrix-button
        >
    }
</mat-dialog-actions>

<ng-template #documentFormTemplate>
    <div [formGroup]="documentForm" class="edit-document-container">
        <cerrix-field-wrapper label="Files" type="secondary">
            @if (dialogData.documents.length > 0) {
                <div class="documents-list">
                    @for (document of dialogData.documents; track $index) {
                        <div class="document-item">
                            <div class="icon-container">
                                @if (document.fileIcon) {
                                    <span
                                        [class]="'document-icon fal fa-' + document.fileIcon"
                                    ></span>
                                }
                            </div>
                            <div class="document-name">{{ document.name }}</div>
                            <div class="document-action">
                                @if (dialogData.showDelete) {
                                    <cerrix-confirmation-button
                                        btnLabel="Delete?"
                                        (onConfirmationClick)="onRemoveFile(document)"
                                    >
                                    </cerrix-confirmation-button>
                                }
                            </div>
                        </div>
                        @if (document.uploadedBy && document.createdOn) {
                            <div class="document-metadata">
                                Uploaded by {{ document.uploadedBy }} at
                                {{
                                    document.modifiedOn ?? document.createdOn
                                        | dateTimeDisplay: true
                                }}
                            </div>
                        }
                    }
                </div>
            }
            @if (dialogData.openReason !== "View") {
                <cerrix-drop-area
                    [multiple]="false"
                    [dataUiid]="'incident-document-popup-list'"
                    (onFileSelection)="onFileSelection($event)"
                ></cerrix-drop-area>
            }
        </cerrix-field-wrapper>

        <cerrix-field-wrapper class="document-type" label="Document Type" type="secondary">
            <cerrix-select
                formControlName="documentTypeId"
                [options]="dialogData.documentTypes"
                [dataUiid]="'incident-document-popup-type-select'"
            ></cerrix-select>
        </cerrix-field-wrapper>
        <cerrix-field-wrapper label="Description" type="secondary">
            <cerrix-textarea
                formControlName="description"
                [dataUiid]="'incident-document-popup-description'"
            ></cerrix-textarea>
        </cerrix-field-wrapper>
    </div>
</ng-template>
<ng-template #documentHistoryTemplate>
    <cerrix-accordion-group [multiple]="true" class="document-history-container">
        @for (historyDocument of historyDocuments; track $index) {
            <cerrix-edit-document-history-item
                [document]="historyDocument"
                (emitDownload)="onDownload($event)"
            ></cerrix-edit-document-history-item>
        }
    </cerrix-accordion-group>
</ng-template>
